// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ColumnsContainer } from "@components";
import type { Rows } from "@components/columns-container/types";
import { formatDate } from "@transformers/date";

type Props = $Exact<{
  data: Object,
  ...PropsFromLocalize,
}>;

const AppealDetailsView = props => {
  const { data } = props;

  const getRows = () => {
    const appeal = data.content?.appeal;
    if (!appeal) return [];

    if (appeal.isActive) {
      return [
        {
          columns: [
            {
              data: [
                [props.t("STATUS"), props.t("ACTIVE")],
                [props.t("APPEAL_INSTRUCTIONS"), appeal.instruction],
              ],
            },
            {
              data: [
                [props.t("HEARING_KPI_DAYS"), appeal.kpiDays],
                [
                  props.t("APPEAL_FORM"),
                  appeal.appealForm ? (
                    <a
                      key={appeal.appealForm}
                      href={appeal.appealForm}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pointer"
                    >
                      {data.appealConfig.appealForm.fileName}
                    </a>
                  ) : null,
                ],
              ],
            },
          ],
        },
      ];
    }

    return [
      {
        columns: [
          {
            data: [[props.t("STATUS"), props.t("INACTIVE")]],
          },
        ],
      },
    ];
  };

  return <ColumnsContainer rows={getRows()} columnContainerClassName="gs-container" />;
};

export default localize()(AppealDetailsView);
